// lib/courses/translate-server-error.ts
// Server actions return English error strings. Client-side forms map them to
// i18n keys here so users on /ar/* see Arabic toasts. Unrecognised strings
// fall through unchanged.

export const SERVER_ERROR_TO_KEY: Record<string, string> = {
  "Please check the form fields": "validation",
  "Course not found": "courseNotFound",
  "Course is not open for registration": "courseClosed",
  "This course is internal-only": "courseInternal",
  "Course is full": "courseFull",
  "Discount code is invalid or expired": "discountInvalid",
  "Could not validate discount code": "discountValidate",
  "You are already registered for this course": "alreadyRegistered",
  "Could not save registration": "saveFailed",
  "You are already on the wait-list for this course": "alreadyOnWaitlist",
  "Could not save wait-list entry": "saveWaitlistFailed",
  "Feedback opens after the course has ended": "feedbackEnded",
  "You have already submitted feedback for this course": "feedbackDuplicate",
  "Could not save feedback": "saveFeedbackFailed",
  "Too many submissions — please try again later": "rateLimited",
  "CAPTCHA verification failed": "captcha",
};

export function translateServerError(
  err: string | null | undefined,
  t: (key: string) => string,
): string {
  if (!err) return "";
  const key = SERVER_ERROR_TO_KEY[err.trim()];
  return key ? t(key) : err;
}
